import React from 'react';
import css from './css.module.less';
import { EnumModuleType } from 'src/types/common/module';
import _ImageCarousel from 'src/constrains/DraggableModules/Components/ResponsiveImageCarousel';
import _ProductCarousel from 'src/constrains/DraggableModules/Components/ResponsiveProductCarousel';
import _ContentPageCarousel from 'src/constrains/DraggableModules/Components/ResponsiveContentPageCarousel';
import DataHOC from 'src/constrains/DraggableModules/Components/HOC/DataProcessHOC';
import { AdaSelect } from 'src/constrains/DraggableModules/Components/AdaptorSelection';
import { EPreviewSize } from 'src/types/common/SalesChannel';

const ResponsiveCarouselAdaptor = (props) => {
  const { staticData, onModuleTypeChange, draggableId, extraProps, ...rest } =
    props;
  const { breakpoint } = extraProps || {};
  const isConvertible = breakpoint !== EPreviewSize.WIDE;
  //console.log('onModuleTypeChange', onModuleTypeChange);
  const { moduleType } = staticData;
  // console.log('moduleType', moduleType);
  const handleOnModuleTypeChange = (e) => {
    //console.log('type', e);
    const type = e;
    //console.log('type', type);
    const data = { moduleType: type, id: draggableId };
    //console.log('data1', data);
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };
  const Dict = React.useMemo(() => {
    return {
      [EnumModuleType.ResponsiveImageCarousel]: _ImageCarousel,
      [EnumModuleType.ResponsiveProductCarousel]: _ProductCarousel,
      [EnumModuleType.ResponsiveContentCarousel]: _ContentPageCarousel,
    };
  }, []);
  const generateModule = () => {
    const Module = Dict[moduleType];
    const _props = { ...rest, extraProps };
    return (
      <Module {..._props} draggableId={draggableId} staticData={staticData} />
    );
  };
  return (
    <div className={css.container}>
      {!isConvertible && (
        <AdaSelect
          title='Carousel Type'
          value={moduleType}
          onChange={handleOnModuleTypeChange}
          list={[
            {
              value: EnumModuleType.ResponsiveContentCarousel,
              label: 'Content Page',
            },
            {
              value: EnumModuleType.ResponsiveImageCarousel,
              label: 'Image',
            },
            {
              value: EnumModuleType.ResponsiveProductCarousel,
              label: 'Product Page',
            },
          ]}
        />
      )}

      {/* <AdaSelection
        title='Carousel Type'
        list={[
          {
            value: EnumModuleType.Carousel,
            label: 'Image',
            className: css.radioItem,
          },
          {
            value: EnumModuleType.ProductCarousel,
            label: 'Product',
            className: css.radioItem,
          },
          {
            value: EnumModuleType.ArticleCarousel,
            label: 'Content Page',
          },
        ]}
        value={moduleType}
        onChange={handleOnModuleTypeChange}
      />{' '} */}
      {/* <Section bottomBorder>
        <ItemWrapper title='Carousel Type'>
          <Radio
            className={css.radioContainer}
            radioList={[
              {
                value: EnumModuleType.Carousel,
                label: 'Carousel',
                className: css.radioItem,
              },
              {
                value: EnumModuleType.ProductCarousel,
                label: 'Product Carousel',
              },
            ]}
            value={moduleType}
            onChange={handleOnModuleTypeChange}
          />
        </ItemWrapper>
      </Section> */}
      {generateModule()}
    </div>
  );
};
export default DataHOC(ResponsiveCarouselAdaptor);
